// extracted by mini-css-extract-plugin
export default {"container":"Home_container__zrtew","section":"Home_section__deVnk"};